import useEventActions from './useEventActions/useEventActions'
import useFlags from './useFlags'

const useFreeSession = () => {
  const { firstEventForFree } = useFlags()
  const { reservedEventsCount } = useEventActions()

  const allowBookingForFree =
    // false &&
    firstEventForFree && reservedEventsCount === 0

  return { allowBookingForFree }
}

export default useFreeSession
